import {Link} from "react-router-dom";
import arrowIcon from '../assets/icons/chevron-right.png';


function LinksSection({content}: any) {
    return (
        <div className="w-full bg-white py-8 xl:py-16">
            <div className="container max-w-3xl">
                <h2 className="font-sweing text-4xl font-normal text-grey-900 mb-4">{content.title}</h2>
                {content.text && content.text.length && <p className="font-body text-sm mb-4">{content.text}</p>}
                <div className="flex flex-col lg:flex-row gap-2.5">
                    {content.links.map((link: any, index: number) => {
                        return (
                            <Link to={link.url} key={index} className="flex-1">
                                <div className="flex justify-between items-center gap-4 bg-grey-200 p-4 rounded">
                                    <div>
                                        <h3 className="font-sweing text-2xl text-grey-900 mb-1.5">{link.title}</h3>
                                        {link.text && link.text.length && <p className="font-body text-sm text-grey-900">{link.text}</p>}
                                    </div>
                                    <div className="w-6">
                                        <img src={arrowIcon} width="7" height="12" alt={link.title}/>
                                    </div>
                                </div>
                            </Link>
                        );
                    })}
                </div>


            </div>
        </div>
    )
        ;
}

export default LinksSection;